import { useSelector, useDispatch } from 'react-redux';
import {
    Segment,
    Grid,
    Button,
    Message,
    Form
} from 'semantic-ui-react';

import { registrationInProgress, registrationProcessed } from './userRegistrationSlice'
import { Field, reduxForm } from 'redux-form';
import { getCommonAPI, renderTextInput, renderSelectInput, renderCheckbox } from 'hpp-fe-common'
import { signOut } from '../../auth/authSlice';
import store from '../../../store';


const UserRegistration = (props) => {

    const dispatch = useDispatch();
    const { countries, companyTypes } = useSelector(state => state?.app)
    const { loading, submitted, error, errorMessage, errorMessageData } = useSelector(state => state.userRegistration)

    const selectedCountryId = useSelector(state => state?.form?.registerDPP?.values?.country);
    const selectedCountry = countries?.find(c => c.value === selectedCountryId);
    const isSriLanka = selectedCountry?.text === 'Sri Lanka';

    const selectedCompanyTypeId = useSelector(state => state?.form?.registerDPP?.values?.companyTypeSelected);
    const selectedCompanyType = companyTypes?.find(ct => ct.value === selectedCompanyTypeId);
    const isInstaller = selectedCompanyType?.key === 'inst';


    const onSubmit = (formValues) => {
        const { firstName, lastName, contactNumber, country, companyTypeSelected, companyNameEntered, purchaseCompanyNameEntered, province, city } = formValues

        dispatch(registrationInProgress())

        //submit registrationForm to register
        getCommonAPI().post('/api_v1/auth/user/register?portal=inst', {
            email: props?.email,
            firstName,
            lastName,
            contactNumber,
            companyTypeSelected,
            companyNameEntered,
            purchaseCompanyNameEntered,
            country,
            province: (isSriLanka && isInstaller) ? (province || null) : null,
            city: (isSriLanka && isInstaller) ? (city || null) : null,
            registrationSource: "ssp-portal"
        })
            .then(({ data }) => {
                if(data.authenticated === false){
                    return dispatch(signOut({
                        error: true,
                        errorMessage: data.errorMessage,
                        errorMessageData: data.errorMessageData
                    }))
                }
                dispatch(registrationProcessed(data))
            })
            .catch(error => {
                dispatch(registrationProcessed({
                    error: true,
                    errorMessage: 'Unidentified error. Please contact syatem administrator',
                    errorMessageData: error.toString()
                }))
            })

    }


    return (
        <Segment textAlign='center' basic loading={loading}>

            <Grid centered columns={2}>

                {
                    //Checking if the submittion is completed
                    submitted ?
                        //Form is submitted. Show success message
                        <Grid.Column>
                            <Message info>
                                <Message.Header>Your data successfully submitted.</Message.Header>
                                <p>Please wait till we review and approve your account. Usually this process will be completed within 7 days. You can log out now and login later to check the status </p>
                            </Message>
                        </Grid.Column>
                        :
                        //Form is not submitted. Show form
                        <Grid.Column>
                            <Message info>
                                <Message.Header>You must register before you can start using this portal.</Message.Header>
                                <p>Please submit below details. </p>
                                <p>If you are not a Hikvision authorized partner please DO NOT register </p>
                            </Message>
                            {
                                error &&
                                <Message negative>
                                    <Message.Header>Submitting Failed</Message.Header>
                                    <p>{errorMessage ? errorMessage : ''}</p>
                                    <p>{errorMessageData ? errorMessageData.toString() : ''}</p>
                                </Message>
                            }

                            <Form autoComplete='off'>
                                <Form.Group widths='equal'>
                                    <Form.Field width={4}>
                                        <Field
                                            name='firstName'
                                            component={renderTextInput}
                                            otherProps={{
                                                label: 'First Name',
                                                placeholder: 'First Name'
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <Field
                                            name='lastName'
                                            component={renderTextInput}
                                            otherProps={{
                                                label: 'Last Name',
                                                placeholder: 'Last Name'
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field width={8}>
                                        <Field
                                            name='contactNumber'
                                            component={renderTextInput}
                                            otherProps={{
                                                label: 'Contact Number',
                                                placeholder: 'Ex: 0712345678'
                                            }}
                                        />
                                    </Form.Field>

                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Field
                                            name='companyNameEntered'
                                            component={renderTextInput}
                                            otherProps={{
                                                label: 'Company Name',
                                                placeholder: 'Company Name'
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Field
                                            name='companyTypeSelected'
                                            component={renderSelectInput}
                                            otherProps={{
                                                fluid: true,
                                                label: 'Your Company Type',
                                                placeholder: 'Your Company Type',
                                                options: companyTypes
                                            }}
                                        />
                                    </Form.Field>
                                </Form.Group>

                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Field
                                            name='purchaseCompanyNameEntered'
                                            component={renderTextInput}
                                            otherProps={{
                                                label: 'Name of the Company that You Purchase Items',
                                                placeholder: 'Name of the Company that You Purchase Items'
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Field
                                            name='country'
                                            component={renderSelectInput}
                                            otherProps={{
                                                fluid: true,
                                                label: 'Your Country',
                                                placeholder: 'Your Country',
                                                options: countries
                                            }}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                {isSriLanka && isInstaller && (
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <Field name='province' component={renderSelectInput}
                                                otherProps={{
                                                    fluid: true,
                                                    label: 'Province',
                                                    placeholder: 'Select Province',
                                                    options: [
                                                        { key: 'western', value: 'western', text: 'Western Province' },
                                                        { key: 'central', value: 'central', text: 'Central Province' },
                                                        { key: 'southern', value: 'southern', text: 'Southern Province' },
                                                        { key: 'northern', value: 'northern', text: 'Northern Province' },
                                                        { key: 'eastern', value: 'eastern', text: 'Eastern Province' },
                                                        { key: 'northWestern', value: 'northWestern', text: 'North Western Province' },
                                                        { key: 'northCentral', value: 'northCentral', text: 'North Central Province' },
                                                        { key: 'uva', value: 'uva', text: 'Uva Province' },
                                                        { key: 'sabaragamuwa', value: 'sabaragamuwa', text: 'Sabaragamuwa Province' },
                                                    ]
                                                }}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Field name='city' component={renderTextInput}
                                                otherProps={{ label: 'City', placeholder: 'City' }}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                )}
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Field
                                            name='agreement'
                                            component={renderCheckbox}
                                            otherProps={{
                                                label: `I confirm that above details are true and correct. And I have no issue to use ${props?.email} as my primary email to access hik-portal.com and it's services`
                                            }}
                                        />
                                    </Form.Field>

                                </Form.Group>
                                <Button onClick={props.handleSubmit(onSubmit)}>Submit</Button>
                            </Form>
                        </Grid.Column>

                }

            </Grid>
        </Segment>
    )
}


const validate = (values) => {
    const errors = {}
    const {
        companyNameEntered,
        companyTypeSelected,
        firstName,
        lastName,
        contactNumber,
        purchaseCompanyNameEntered,
        country,
        agreement,
        province,
        city
    } = values;

    const appCountries = store.getState()?.app?.countries;
    const selectedCountry = appCountries?.find(c => c.value === country);
    const isSriLanka = selectedCountry?.text === 'Sri Lanka';

    const appCompanyTypes = store.getState()?.app?.companyTypes;
    const selectedCompanyType = appCompanyTypes?.find(ct => ct.value === companyTypeSelected);
    const isInstaller = selectedCompanyType?.key === 'inst';

    if (!companyNameEntered) { errors.companyNameEntered = "Required" }
    if (!companyTypeSelected) { errors.companyTypeSelected = "Required" }
    if (!firstName) { errors.firstName = "Required" }
    if (!lastName) { errors.lastName = "Required" }
    if (!contactNumber) {
        errors.contactNumber = "Required"
    } else {
        if (!(/^[0-9][0-9]{8,14}$/.test(contactNumber))) {
            errors.contactNumber = "Please enter valid phone number"
        }
    }
    if (!purchaseCompanyNameEntered) { errors.purchaseCompanyNameEntered = "Required" };
    if (!country) { errors.country = "Required" };
    if (isSriLanka && isInstaller) {
        if (!province) { errors.province = "Required" }
        if (!city) { errors.city = "Required" }
    }
    if (!agreement) { errors.agreement = "Required" };

    return errors;
}

export default reduxForm({
    form: "registerDPP",
    validate
})(UserRegistration)
